__turbopack_context__.v({
  "hasIcon": "BucketHeader-module-scss-module__lOP-7q__hasIcon",
  "premium": "BucketHeader-module-scss-module__lOP-7q__premium",
  "root": "BucketHeader-module-scss-module__lOP-7q__root",
  "subtitle": "BucketHeader-module-scss-module__lOP-7q__subtitle",
  "title": "BucketHeader-module-scss-module__lOP-7q__title",
});
